export default "__VITE_ASSET__B18F3XD2__"